export const HOST_URL = process.env.REACT_APP_API_HOST;
export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY;
